import { InvoiceTaskPhase } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 1790. 請求タスクフェーズ一覧
 * [GET] /invoice_task_phases
 */
const invoiceTaskPhases = (): Promise<InvoiceTaskPhase[]> => {
  return axios.get(`/api/invoice_task_phases`);
};

export const useInvoiceTaskPhases = () => {
  return useQuery({
    queryKey: ['invoice_task_phases'],
    queryFn: () => invoiceTaskPhases()
  });
};
